import { ConvexReactClient } from "convex/react";

const rawConvexUrl = String(import.meta.env.VITE_CONVEX_URL || "").trim();

export const convexUrl: string | null = rawConvexUrl || null;
export const isConvexConfigured = Boolean(convexUrl);

export const clerkPublishableKey: string | null = String(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || "").trim() || null;
export const isClerkConfigured = Boolean(clerkPublishableKey);

let client: ConvexReactClient | null = null;

export function getConvexClient(): ConvexReactClient | null {
  if (!convexUrl) return null;
  if (!client) {
    client = new ConvexReactClient(convexUrl, { unsavedChangesWarning: false });
  }
  return client;
}
